module.exports = __webpack_public_path__ + "media/r_franzosen.adde4105.mp3";